import { POS } from './Pos';
export default POS;
